<div mat-dialog-content>
  <div *ngIf="botoes; else pergunta">
    <h3>O que deseja fazer?</h3>
    <button (click)="botoes = false" class="w-100 mb-3" mat-stroked-button>
      Finalizar contato
    </button>
    <button (click)="enviarFinalFila()" class="w-100 mb-2" mat-stroked-button>
      Enviar para final da fila
    </button>
  </div>
  <ng-template #pergunta>
    <form [formGroup]="motivoFinalizarForm" (submit)="finalizarContato()">
      <div class="pergunta mb-2">
        <h3>Por qual motivo está finalizando o contato?</h3>
        <textarea
          matInput
          formControlName="motivo"
          class="form-control"
          placeholder="Escreva aqui..."
        ></textarea>
      </div>
      <div class="alert alert-danger" *ngIf="error" [innerHTML]="error"></div>
      <button type="submit" class="w-100 mb-3" mat-stroked-button>
        Encerrar contato sem ação
      </button>
    </form>
  </ng-template>
</div>
